import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/views/layout/layout'
// import orderRouter from './order'

const agentManageRouter = { // 代理管理
  path: '/agentManage',
  component: Layout,
  redirect: 'agentManage',
  alwaysShow: true,
  meta: {
    title: '代理管理',
    icon: 'agent',
    roles: ['agent']
  },
  children: [
    {
      path: 'agentList',
      component: resolve => require(['@/views/agent/agentManage/agentList'], resolve),
      name: 'AgentList',
      meta: { title: '代理列表', noCache: false }
    },
    {
      path: 'ProfitReport',
      component: resolve => require(['@/views/agent/agentManage/ProfitReport'], resolve),
      name: 'ProfitReport',
      meta: { title: '代理分润统计报表', noCache: false }
    }
  ]
}

export default agentManageRouter



// WEBPACK FOOTER //
// ./src/router/agent/agentManage.js